import React from "react";
import { Container } from "react-bootstrap";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import "../../App.css";

const ESignConsent: React.FC = () => {
  return (
    <>
      <Header />
      <Container className="py-5 mt-4" style={{ maxWidth: 820 }}>
        <h1 className="fw-bold mb-1">E-Sign Consent</h1>
        <p className="text-secondary small mb-5">Last updated: August 2026</p>

        <Section title="1. Purpose">
          ARMF's onboarding and KYC process asks you to certify and agree to certain documents
          electronically, rather than on paper. This E-Sign Consent explains that process,
          consistent with the Electronic Transactions Act 1999 (Cth), which recognises electronic
          signatures and records as legally valid.
        </Section>

        <Section title="2. Your Consent">
          By ticking a certification checkbox or otherwise confirming agreement within the ARMF
          platform, you consent to: (a) sign documents and certifications electronically; (b)
          receive disclosures, notices, and records from ARMF electronically (including by
          email); and (c) treat these electronic actions as having the same legal effect as a
          handwritten signature or paper document.
        </Section>

        <Section title="3. Withdrawing Consent">
          You may withdraw your consent to electronic signing and delivery at any time by
          contacting <a href="mailto:support@armf.com">support@armf.com</a>. Withdrawing consent
          may delay or prevent completion of onboarding, as some steps rely on electronic
          certification.
        </Section>

        <Section title="4. System Requirements">
          To access and retain electronic records from ARMF, you'll need a device with a current
          web browser, a valid email address, and the ability to save or print electronic
          documents.
        </Section>

        <Section title="5. Contact Us">
          If you have questions about this E-Sign Consent, please contact us at{" "}
          <a href="mailto:support@armf.com">support@armf.com</a>.
        </Section>
      </Container>
      <Footer full={true} />
    </>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="mb-4">
    <h5 className="fw-semibold mb-2">{title}</h5>
    <div className="text-secondary" style={{ lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default ESignConsent;
